module.exports = __webpack_public_path__ + "static/media/maheswari.58c99d2c.png";